import { useEffect } from 'react';
import { getCheckoutSessionConversion } from '../../api/payment';
import { GOOGLE_ADS_PURCHASE_CONVERSION } from '../constants';

// Guards against duplicate sends within one page load (e.g. StrictMode double effects).
// Google Ads also dedupes on transaction_id across reloads.
const reportedSessionIds = new Set();

// Reports a Google Ads Purchase conversion when Stripe redirects back with
// ?checkout=success&session_id=... (all checkout return pages call this).
const useCheckoutConversion = search => {
    useEffect(() => {
        const query = new URLSearchParams(search);
        const sessionId = query.get('session_id');
        if (query.get('checkout') !== 'success' || !sessionId || reportedSessionIds.has(sessionId)) return;
        if (typeof window.gtag !== 'function') return;

        reportedSessionIds.add(sessionId);
        getCheckoutSessionConversion(sessionId)
            .then(({ transactionId, value, currency }) => {
                window.gtag('event', 'conversion', {
                    send_to: GOOGLE_ADS_PURCHASE_CONVERSION,
                    value,
                    currency,
                    transaction_id: transactionId,
                });
            })
            .catch(() => {
                reportedSessionIds.delete(sessionId);
            });
    }, [search]);
};

export default useCheckoutConversion;
